import React from 'react';
import Box from "@mui/material/Box";
import {buildStyles, CircularProgressbar} from "react-circular-progressbar";
import {COLORS} from "../../ui/Theme";
import Typography from "@mui/material/Typography";
import {Skeleton} from "@mui/material";

const ProfileSubscriptionRemainedDaysSkeleton = () => {

    return (
        <Box sx={{
            display: "flex",
            gap: "30px",
        }}>
            <Box sx={{width: "80px"}}>
                <CircularProgressbar
                    counterClockwise={true}
                    value={0}
                    // maxValue={data.total_days}
                    // text={data.remained_days ? data.remained_days + " " + "روز" : "اتمام"}
                    styles={buildStyles({
                        pathColor: COLORS.GRAY,
                        textColor: COLORS.BLACK,
                        trailColor: COLORS.SOFTGRAY,
                        textSize: '14px',
                    })}
                />
            </Box>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "5px"
            }}>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        اشتراک:
                    </Typography>
                    <Skeleton variant="text" width="123px" sx={{ fontSize: '14px' }}/>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        تاریخ شروع:
                    </Typography>
                    <Skeleton variant="text" width="67px" sx={{ fontSize: '14px' }}/>
                </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <Typography sx={{
                        fontSize: "12px",
                        color: COLORS.DARKGRAY,
                        fontWeight: "bold"
                    }}>
                        تاریخ پایان:
                    </Typography>
                    <Skeleton variant="text" width="67px" sx={{ fontSize: '14px' }}/>
                </Box>
            </Box>
        </Box>
    );
};

export default ProfileSubscriptionRemainedDaysSkeleton;